import React, { useState, useMemo } from 'react';
import { Plus, Search, MessageCircle, Mail, Headphones } from 'lucide-react';
import { FAQ, FLAVOUR_ORDER, FLAVOURS } from '../data/mock';
import Reveal from '../components/Reveal';

function Item({ item, open, onToggle }) {
  return (
    <div className="border border-white/10 rounded-xl overflow-hidden bg-[#0b0b0b]">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
        <span className="font-cond tracking-wide text-white/90">{item.q}</span>
        <Plus className={`w-5 h-5 shrink-0 text-[#ff2d2d] transition-transform duration-300 ${open?'rotate-45':''}`} />
      </button>
      <div className="grid transition-all duration-300" style={{ gridTemplateRows: open?'1fr':'0fr' }}>
        <div className="overflow-hidden"><p className="px-5 pb-5 text-white/60 text-sm leading-relaxed">{item.a}</p></div>
      </div>
    </div>
  );
}

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);
  const [q, setQ] = useState('');
  const list = useMemo(() => FAQ.filter((f) => f.q.toLowerCase().includes(q.toLowerCase()) || f.a.toLowerCase().includes(q.toLowerCase())), [q]);

  return (
    <div className="pt-24">
      <section className="py-14 md:py-16">
        <div className="max-w-[1000px] mx-auto px-5">
          <Reveal className="mb-8">
            <p className="font-cond tracking-[0.3em] text-white/40 mb-3">FAQ</p>
            <h1 className="font-display text-5xl md:text-7xl">QUESTIONS?<br /><span className="text-flavour flavour-transition">WE'VE GOT ANSWERS.</span></h1>
            <p className="text-white/60 mt-4">Everything you need to know about S-MAN, the formula, flavours, ordering and delivery.</p>
          </Reveal>
          <div className="relative mb-8 max-w-lg">
            <Search className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
            <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="What would you like to know?" className="w-full bg-white/[0.04] border border-white/10 rounded-xl pl-11 pr-4 py-3.5 outline-none focus:border-white/30" />
          </div>

          <div className="grid lg:grid-cols-[1.6fr_1fr] gap-8">
            <div className="space-y-3">
              {list.map((item, i) => (<Item key={item.q} item={item} open={openIdx===i} onToggle={()=>setOpenIdx(openIdx===i?-1:i)} />))}
              {list.length===0 && <p className="text-white/40">No questions match your search.</p>}
            </div>
            <div className="rounded-2xl border border-white/10 bg-[#0b0b0b] p-6 h-fit">
              <p className="font-cond tracking-wide" style={{color:'#ff2d2d'}}>NEED HELP?</p>
              <h3 className="font-display text-3xl mt-1">STILL HAVE A QUESTION?</h3>
              <p className="text-white/50 text-sm mt-2">Our team is here to help.</p>
              <div className="mt-5 space-y-3">
                {[{i:MessageCircle,l:'CHAT WITH US'},{i:Mail,l:'EMAIL S-MAN'},{i:Headphones,l:'CONTACT SUPPORT'}].map((c)=>(
                  <button key={c.l} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg border border-white/10 hover:border-[#ff2d2d]/60 hover:bg-white/[0.03] transition-all font-cond tracking-wide text-sm"><c.i className="w-5 h-5 text-[#ff2d2d]" /> {c.l}</button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 bg-[#080808] border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {FLAVOUR_ORDER.map((id)=>{const f=FLAVOURS[id];return(
            <div key={id} className="text-center"><img src={f.fruit} alt={f.name} loading="lazy" className="w-16 h-16 rounded-full object-cover border-2 mx-auto mb-2" style={{borderColor:f.primary}} /><p className="font-cond text-sm" style={{color:f.primary}}>{f.name}</p><p className="text-xs text-white/40">{f.tagline}</p></div>
          );})}
        </div>
      </section>
    </div>
  );
}
